import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import IddStory from '../components/IddStory.jsx';
import PageParts from '../components/PageParts.jsx';
import AgenticDevPage from './AgenticDevPage.jsx';

// The IDD page: the story of modernising grown software and of traceable AI
// development on top, then the owner's explanation of Intent-Driven
// Development exactly as it is. The two parts are the anchors `legacy` and
// `method`; a link with one of them opens the page at that part.
const IddPage = () => {
  const location = useLocation();

  useEffect(() => {
    const anchor = location.hash.replace('#', '');
    if (!anchor) {
      return undefined;
    }
    const timer = window.setTimeout(() => {
      document.getElementById(anchor)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <IddStory />
      <div id="method" className="page-anchor page-parts-bar">
        <div className="site-main">
          <PageParts current="method" />
        </div>
      </div>
      <AgenticDevPage />
    </>
  );
};

export default IddPage;
